import {defineSlotRecipe, defineRecipe} from '@chakra-ui/react3'

export const promotionBannerRecipe = defineRecipe({
    base: {
        width: 'full',
        position: 'relative',
        backgroundColor: 'background.section.strong',
        color: 'text.primary',
        borderRadius: 'xs',
        paddingBlock: 'spacing-16',
        paddingInline: 'spacing-16',
        '--container-inline-padding': {base: 'spacing.spacing-24', s: 'spacing.spacing-32'},
        '--container-total-inline-padding': {base: 'spacing.spacing-24', s: 'spacing.spacing-32'},
        overflowAnchor: 'none'
    }
})

export const promotionItemRecipe = defineSlotRecipe({
    slots: [
        'root',
        'content',
        'iconBox',
        'heading',
        'image',
        'imageBox',
        'textContainer',
        'headingRow'
    ],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: 'full',
            gap: 'spacing-8',
            paddingBottom: 'spacing-16'
        },
        content: {
            color: 'text.primary',
            textStyle: 'body.small'
        },
        iconBox: {
            padding: 'spacing-6',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            borderRadius: 'full',
            justifyContent: 'center',
            width: '1.75rem',
            height: '1.75rem',
            backgroundColor: 'primary.base.white',
            objectFit: 'contain',
            flexShrink: 0
        },
        heading: {
            textStyle: 'headings.small'
        },
        image: {
            objectFit: 'cover',
            width: '4.375rem', // using custom value because no match in defined sizes
            height: '4.375rem', // using custom value because no match in defined sizes
            flexShrink: 0
        },
        imageBox: {
            backgroundColor: 'primary.base.white',
            borderRadius: 'xs',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0,
            width: '4.375rem', // using custom value because no match in defined sizes
            minHeight: '4.375rem', // using custom value because no match in defined sizes
            alignSelf: 'stretch'
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            flex: 1,
            gap: 'spacing-8'
        },
        headingRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'spacing-8'
        }
    },
    variants: {
        colorWorld: {
            cream: {
                iconBox: {backgroundColor: 'secondary.cream'},
                heading: {color: 'secondary.cream'}
            },
            malva: {
                iconBox: {backgroundColor: 'secondary.malva'},
                heading: {color: 'secondary.malva'}
            },
            terracotta: {
                iconBox: {backgroundColor: 'secondary.terracotta'},
                heading: {color: 'secondary.terracotta'}
            },
            fjordblue: {
                iconBox: {backgroundColor: 'secondary.fjordBlue'},
                heading: {color: 'secondary.fjordBlue'}
            },
            cherry: {
                iconBox: {backgroundColor: 'secondary.cherry'},
                heading: {color: 'secondary.cherry'}
            },
            pinegreen: {
                iconBox: {backgroundColor: 'secondary.pineGreen'},
                heading: {color: 'secondary.pineGreen'}
            },
            sunflower: {
                iconBox: {backgroundColor: 'secondary.sunflower'},
                heading: {color: 'secondary.sunflower'}
            }
        },
        mediaType: {
            image: {
                root: {
                    flexDirection: 'row',
                    alignItems: 'stretch'
                }
            }
        },
        hasDetails: {
            true: {
                imageBox: {
                    maxHeight: '6.25rem' // using custom value because no match in defined sizes
                }
            }
        }
    }
})

export const THEME_FOR_COLOR_VARIANT = {
    default: 'light',
    black: 'dark'
}
